const NotFoundPage = () => (
  <>
    <h1>Not Found</h1>
  </>
);

export default NotFoundPage;
